// Comply Dashboard: the routes and the sidebar rows of `wealth.compliance.dashboard` (ADR-0027).
import { Navigate } from 'react-router';
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.dashboard',
    routes: [
        { frontend: 'comply', path: '', lazy: () => import('@/pages/comply/page') },
        {
            frontend: 'comply',
            path: 'dashboard',
            lazy: () => import('@/pages/comply/dashboard/page'),
        },
        // My Page is retired (SEP-299). This route sends a saved link to
        // /comply/my-page to the Comply Dashboard for one release. Remove it in
        // the next release.
        {
            frontend: 'comply',
            path: 'my-page',
            element: <Navigate to="/comply/dashboard" replace />,
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'dashboard',
            label: 'Comply Dashboard',
            href: '/comply/dashboard',
            icon: 'LayoutDashboard',
            group: 'overview',
            order: 1000,
            wip: true,
        },
    ],
});
